var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"x"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"x","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("polygon",{"id":"Fill-1","fill":"#000000","points":"13.855 2.75 8.93700002 7.668 4.14400002 2.875 2.73000002 4.29 7.52400002 9.081 2.85400002 13.752 4.26800002 15.165 8.93700002 10.496 13.698 15.258 15.113 13.844 10.351 9.081 15.269 4.165"}))]);
}

X.defaultProps = {"width":"18px","height":"18px","viewBox":"0 0 18 18","version":"1.1"};

module.exports = X;

X.default = X;



// WEBPACK FOOTER //
// ./src/icons/x.svg